import CloudDownloadRounded from "@material-ui/icons/CloudDownloadRounded";
import DeleteRounded from "@material-ui/icons/DeleteRounded";
import { useCallback, useEffect, useState } from "react";
import BasicButton from "../../components/BasicButton";
import BasicInput from "../../components/BasicInput";
import {
  deleteDocument, getDocumentDownloadUrl, uploadDocument, useExistingDocuments
} from "../../misc/lib/documents";

const DocumentsAdminPanel = () => {
  const [ newDocName, setNewDowcName ] = useState('');
  const [ newDocUploading, setNewDocUploading ] = useState(false);
  const [ newDocError, setNewDocError ] = useState(false);

  const documents = useExistingDocuments();

  const doUploadDocument = useCallback(() => {
    if (!newDocName) {
      setNewDocError(true);
      return;
    }

    setNewDocUploading(true);

    const inputElement = document.createElement('input');
    inputElement.type = 'file'; inputElement.accept = 'application/pdf';
    inputElement.style.display = 'none';
    inputElement.onchange = () => {
      uploadDocument(newDocName, inputElement.files![ 0 ]).then(() => {
        inputElement.remove();
        setNewDowcName('');
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        setNewDocUploading(false);
      });
    };

    document.body.appendChild(inputElement);
    inputElement.click();
  }, [ newDocName ]);

  useEffect(() => {
    setNewDocError(false);
  }, [ newDocName ]);

  return (
    <div className="adminpage-documents-panel">
      <div className="new-document">
        <h2>Új dokumentum</h2>
        <BasicInput placeholder="Dokumentum neve" text={ newDocName }
          onTextChanged={ setNewDowcName } onSubmit={ doUploadDocument }
          error={ newDocError } />
        <BasicButton text="Feltöltés" type="primary"
          onClick={ doUploadDocument } working={ newDocUploading } />
      </div>
      <div className="existing-documents-list">
        <h2>Feltöltött dokumentumok</h2>
        <div className="list">
          { documents.map((doc, i) => (
            <div className="document-card" key={ i }>
              <h3>{ doc.name }</h3>
              <p>ID: <b>{ doc.id }</b></p>
              <span onClick={ () => {
                getDocumentDownloadUrl(doc.id).then((url) => {
                  window.open(url, '_blank');
                });
              } }><CloudDownloadRounded color="inherit" /></span>
              <span onClick={ () => {
                deleteDocument(doc.id);
              } }><DeleteRounded color="inherit" /></span>
            </div>
          )) }
        </div>
      </div>
    </div>
  );
};

export default DocumentsAdminPanel;
